const topics = [
  {
    slug: 'group-event-fund-tracking-without-confusion',
    title: 'How to Track Group Event Funds Without Confusion',
    category: 'Financial Planning',
    excerpt: 'Use a simple collection tracker so everyone knows who paid, what was spent, and how the final balance is shared.',
    readMinutes: 6,
    relatedTool: '/group-collection-report',
  },
  {
    slug: 'start-a-budget-that-actually-works',
    title: 'How to Start a Budget That Actually Works',
    category: 'Budgeting',
    excerpt: 'Create a practical budget using simple buckets so you can spend confidently and still save every month.',
    readMinutes: 6,
    relatedTool: '/salary',
  },
  {
    slug: 'zero-based-budgeting-for-indian-families',
    title: 'Zero Based Budgeting for Indian Families',
    category: 'Budgeting',
    excerpt: 'Assign every rupee a job and remove money leaks from groceries, subscriptions, and impulse spending.',
    readMinutes: 7,
    relatedTool: '/salary',
  },
  {
    slug: 'build-an-emergency-fund-step-by-step',
    title: 'Build an Emergency Fund Step by Step',
    category: 'Financial Planning',
    excerpt: 'Learn how much emergency cash you need, where to keep it, and how to build it without stress.',
    readMinutes: 6,
    relatedTool: '/fixed-income',
  },
  {
    slug: '50-30-20-rule-india-version',
    title: 'The 50-30-20 Rule: India Version',
    category: 'Budgeting',
    excerpt: 'Adapt the classic 50-30-20 rule for rent, family support, and local cost of living realities.',
    readMinutes: 5,
    relatedTool: '/salary',
  },
  {
    slug: 'how-to-track-expenses-without-app-fatigue',
    title: 'How to Track Expenses Without App Fatigue',
    category: 'Budgeting',
    excerpt: 'Use a low effort weekly tracking routine to stay in control without constantly logging every transaction.',
    readMinutes: 5,
    relatedTool: '/general-bill',
  },
  {
    slug: 'best-way-to-plan-annual-financial-goals',
    title: 'Best Way to Plan Annual Financial Goals',
    category: 'Financial Planning',
    excerpt: 'Set realistic yearly money goals and convert them into monthly targets with a progress framework.',
    readMinutes: 7,
    relatedTool: '/goal-sip',
  },
  {
    slug: 'simple-guide-to-sip-for-beginners',
    title: 'Simple Guide to SIP for Beginners',
    category: 'Investing',
    excerpt: 'Understand SIP basics, compounding, and fund selection so you can start investing with confidence.',
    readMinutes: 7,
    relatedTool: '/sip',
  },
  {
    slug: 'lumpsum-vs-sip-when-to-choose-what',
    title: 'Lumpsum vs SIP: When to Choose What',
    category: 'Investing',
    excerpt: 'Compare lumpsum and SIP strategies across market cycles, risk appetite, and goal timelines.',
    readMinutes: 8,
    relatedTool: '/lumpsum',
  },
  {
    slug: 'how-compounding-builds-wealth-over-time',
    title: 'How Compounding Builds Wealth Over Time',
    category: 'Investing',
    excerpt: 'See why time in the market often beats timing the market for long term wealth creation.',
    readMinutes: 6,
    relatedTool: '/compound-interest',
  },
  {
    slug: 'asset-allocation-basics-for-first-investors',
    title: 'Asset Allocation Basics for First Investors',
    category: 'Investing',
    excerpt: 'Build a balanced portfolio across equity, debt, and cash based on your goals and risk profile.',
    readMinutes: 8,
    relatedTool: '/mf-returns',
  },
  {
    slug: 'ppf-vs-epf-vs-vpf-which-is-better',
    title: 'PPF vs EPF vs VPF: Which Is Better',
    category: 'Retirement',
    excerpt: 'Compare lock in, tax treatment, returns, and liquidity across major provident fund options.',
    readMinutes: 8,
    relatedTool: '/ppf',
  },
  {
    slug: 'nps-tier-1-and-tier-2-explained',
    title: 'NPS Tier 1 and Tier 2 Explained',
    category: 'Retirement',
    excerpt: 'Understand contribution limits, tax benefits, withdrawal rules, and annuity choices in NPS.',
    readMinutes: 8,
    relatedTool: '/nps',
  },
  {
    slug: 'how-much-should-you-save-for-retirement',
    title: 'How Much Should You Save for Retirement',
    category: 'Retirement',
    excerpt: 'Estimate retirement corpus requirements using inflation adjusted expenses and longevity assumptions.',
    readMinutes: 7,
    relatedTool: '/retirement',
  },
  {
    slug: 'fire-strategy-for-salaried-professionals',
    title: 'FIRE Strategy for Salaried Professionals',
    category: 'Retirement',
    excerpt: 'Plan Financial Independence and Early Retirement with practical savings rates and withdrawal rules.',
    readMinutes: 9,
    relatedTool: '/fire',
  },
  {
    slug: 'fd-vs-rd-vs-debt-funds-for-safe-returns',
    title: 'FD vs RD vs Debt Funds for Safer Returns',
    category: 'Investing',
    excerpt: 'Evaluate capital safety, return stability, and tax efficiency of low volatility options.',
    readMinutes: 7,
    relatedTool: '/fd',
  },
  {
    slug: 'tax-planning-checklist-before-march',
    title: 'Tax Planning Checklist Before March',
    category: 'Tax',
    excerpt: 'Use this year end checklist to maximize deductions, verify proofs, and avoid rushed decisions.',
    readMinutes: 6,
    relatedTool: '/income-tax',
  },
  {
    slug: 'old-vs-new-tax-regime-decision-framework',
    title: 'Old vs New Tax Regime: Decision Framework',
    category: 'Tax',
    excerpt: 'Pick the right tax regime with a structured comparison of deductions, slabs, and income patterns.',
    readMinutes: 7,
    relatedTool: '/income-tax',
  },
  {
    slug: 'understanding-capital-gains-on-stocks-and-mf',
    title: 'Understanding Capital Gains on Stocks and Mutual Funds',
    category: 'Tax',
    excerpt: 'Learn STCG and LTCG rules, holding periods, and smart booking strategies for tax efficiency.',
    readMinutes: 8,
    relatedTool: '/capital-gain',
  },
  {
    slug: 'how-tds-works-on-salary-and-other-income',
    title: 'How TDS Works on Salary and Other Income',
    category: 'Tax',
    excerpt: 'Decode TDS deductions, Form 26AS checks, and refund planning for smoother tax filing.',
    readMinutes: 7,
    relatedTool: '/tds',
  },
  {
    slug: 'professional-tax-and-payslip-explained',
    title: 'Professional Tax and Payslip Explained',
    category: 'Tax',
    excerpt: 'Understand professional tax deductions by state and how they affect your take home pay.',
    readMinutes: 5,
    relatedTool: '/professional-tax',
  },
  {
    slug: 'home-loan-emi-reduction-strategies',
    title: 'Home Loan EMI Reduction Strategies',
    category: 'Loans',
    excerpt: 'Cut your loan burden using part prepayments, rate renegotiation, and tenure optimization.',
    readMinutes: 8,
    relatedTool: '/loan-prepayment',
  },
  {
    slug: 'personal-loan-vs-credit-card-emi',
    title: 'Personal Loan vs Credit Card EMI',
    category: 'Loans',
    excerpt: 'Compare true borrowing costs and choose the lower interest option for short term needs.',
    readMinutes: 6,
    relatedTool: '/emi',
  },
  {
    slug: 'car-loan-down-payment-how-much-is-right',
    title: 'Car Loan Down Payment: How Much Is Right',
    category: 'Loans',
    excerpt: 'Find the ideal down payment that balances EMI affordability and investment opportunity cost.',
    readMinutes: 6,
    relatedTool: '/emi',
  },
  {
    slug: 'loan-eligibility-factors-banks-check',
    title: 'Loan Eligibility Factors Banks Check',
    category: 'Loans',
    excerpt: 'Know the key eligibility metrics banks evaluate before approving your loan application.',
    readMinutes: 6,
    relatedTool: '/home-loan-eligibility',
  },
  {
    slug: 'fixed-vs-floating-home-loan-rates',
    title: 'Fixed vs Floating Home Loan Rates',
    category: 'Loans',
    excerpt: 'Understand when fixed rates help and when floating rates can save money over loan tenure.',
    readMinutes: 7,
    relatedTool: '/emi',
  },
  {
    slug: 'how-to-improve-credit-score-before-loan',
    title: 'How to Improve Credit Score Before a Loan',
    category: 'Loans',
    excerpt: 'Improve repayment history, utilization, and report accuracy to qualify for better loan terms.',
    readMinutes: 7,
    relatedTool: '/emi',
  },
  {
    slug: 'rent-vs-buy-calculation-framework',
    title: 'Rent vs Buy: A Practical Calculation Framework',
    category: 'Real Estate',
    excerpt: 'Use net cost of ownership, maintenance, and opportunity cost to make a smarter decision.',
    readMinutes: 8,
    relatedTool: '/rent-vs-buy',
  },
  {
    slug: 'rental-yield-what-good-looks-like',
    title: 'Rental Yield: What Good Looks Like',
    category: 'Real Estate',
    excerpt: 'Measure gross and net rental yield and assess if a property is really investment worthy.',
    readMinutes: 6,
    relatedTool: '/rental-yield',
  },
  {
    slug: 'stamp-duty-and-registration-cost-planning',
    title: 'Stamp Duty and Registration Cost Planning',
    category: 'Real Estate',
    excerpt: 'Plan for upfront transaction costs so your property budget does not break at the final stage.',
    readMinutes: 5,
    relatedTool: '/stamp-duty',
  },
  {
    slug: 'real-estate-vs-equity-for-long-term-goals',
    title: 'Real Estate vs Equity for Long Term Goals',
    category: 'Real Estate',
    excerpt: 'Compare return potential, liquidity, and concentration risk before committing major capital.',
    readMinutes: 8,
    relatedTool: '/cagr',
  },
  {
    slug: 'insurance-basics-term-health-and-motor',
    title: 'Insurance Basics: Term, Health, and Motor',
    category: 'Insurance',
    excerpt: 'Cover your financial downside with the right mix of insurance products and adequate sums insured.',
    readMinutes: 7,
    relatedTool: '/salary',
  },
  {
    slug: 'how-much-term-insurance-do-you-need',
    title: 'How Much Term Insurance Do You Need',
    category: 'Insurance',
    excerpt: 'Estimate life cover based on liabilities, family expenses, and future goals.',
    readMinutes: 6,
    relatedTool: '/retirement',
  },
  {
    slug: 'health-insurance-mistakes-first-time-buyers',
    title: 'Health Insurance Mistakes First Time Buyers Make',
    category: 'Insurance',
    excerpt: 'Avoid low coverage, poor claim network, and hidden waiting periods when buying health insurance.',
    readMinutes: 7,
    relatedTool: '/salary',
  },
  {
    slug: 'sinking-funds-for-big-upcoming-expenses',
    title: 'Sinking Funds for Big Upcoming Expenses',
    category: 'Financial Planning',
    excerpt: 'Plan ahead for school fees, vacations, gadget upgrades, and annual bills without using debt.',
    readMinutes: 6,
    relatedTool: '/school-fees-receipt',
  },
  {
    slug: 'create-a-debt-payoff-plan-snowball-vs-avalanche',
    title: 'Create a Debt Payoff Plan: Snowball vs Avalanche',
    category: 'Financial Planning',
    excerpt: 'Choose the payoff method that matches your behavior and minimizes total interest.',
    readMinutes: 7,
    relatedTool: '/loan-prepayment',
  },
  {
    slug: 'salary-structuring-to-optimize-taxes',
    title: 'Salary Structuring to Optimize Taxes',
    category: 'Tax',
    excerpt: 'Review salary components and allowances to improve take home under compliant structures.',
    readMinutes: 8,
    relatedTool: '/salary',
  },
  {
    slug: 'gratuity-calculation-rules-you-should-know',
    title: 'Gratuity Calculation Rules You Should Know',
    category: 'Retirement',
    excerpt: 'Understand eligibility, formula, and tax treatment of gratuity for private and public employees.',
    readMinutes: 6,
    relatedTool: '/gratuity',
  },
  {
    slug: 'how-inflation-changes-your-goal-target',
    title: 'How Inflation Changes Your Goal Target',
    category: 'Financial Planning',
    excerpt: 'Adjust your savings goals for education, home, and retirement based on realistic inflation rates.',
    readMinutes: 7,
    relatedTool: '/inflation',
  },
  {
    slug: 'build-a-child-education-corpus',
    title: 'How to Build a Child Education Corpus',
    category: 'Financial Planning',
    excerpt: 'Estimate future education costs and design an investment plan with annual step up contributions.',
    readMinutes: 8,
    relatedTool: '/goal-sip',
  },
  {
    slug: 'goal-based-investing-for-young-professionals',
    title: 'Goal Based Investing for Young Professionals',
    category: 'Investing',
    excerpt: 'Align investment products to specific goals instead of chasing random returns and market noise.',
    readMinutes: 7,
    relatedTool: '/goal-sip',
  },
  {
    slug: 'behavioral-biases-that-hurt-investors',
    title: 'Behavioral Biases That Hurt Investors',
    category: 'Behavioral Finance',
    excerpt: 'Spot common money biases like herd behavior and loss aversion that derail long term plans.',
    readMinutes: 6,
    relatedTool: '/mf-returns',
  },
  {
    slug: 'when-to-rebalance-your-portfolio',
    title: 'When to Rebalance Your Portfolio',
    category: 'Investing',
    excerpt: 'Use threshold and calendar based rebalancing to control risk and maintain strategy discipline.',
    readMinutes: 7,
    relatedTool: '/mf-returns',
  },
  {
    slug: 'safe-withdrawal-strategy-for-retirees',
    title: 'Safe Withdrawal Strategy for Retirees',
    category: 'Retirement',
    excerpt: 'Build a withdrawal plan that balances income stability, inflation, and longevity risk.',
    readMinutes: 8,
    relatedTool: '/swp',
  },
  {
    slug: 'monthly-cash-flow-planning-for-freelancers',
    title: 'Monthly Cash Flow Planning for Freelancers',
    category: 'Business Finance',
    excerpt: 'Create stable income systems with invoice discipline, tax buffers, and variable expense controls.',
    readMinutes: 7,
    relatedTool: '/invoice',
  },
  {
    slug: 'pricing-services-using-markup-and-margin',
    title: 'Pricing Services Using Markup and Margin',
    category: 'Business Finance',
    excerpt: 'Set profitable prices by understanding cost base, markup, margin, and target net income.',
    readMinutes: 6,
    relatedTool: '/markup',
  },
  {
    slug: 'break-even-analysis-for-small-businesses',
    title: 'Break Even Analysis for Small Businesses',
    category: 'Business Finance',
    excerpt: 'Find your break even point and use it to set sales goals, pricing, and monthly operating plans.',
    readMinutes: 6,
    relatedTool: '/breakeven',
  },
  {
    slug: 'gst-basics-for-new-entrepreneurs',
    title: 'GST Basics for New Entrepreneurs',
    category: 'Business Finance',
    excerpt: 'Understand GST registration triggers, invoice requirements, and filing basics for compliance.',
    readMinutes: 8,
    relatedTool: '/gst',
  },
  {
    slug: 'invoice-best-practices-to-get-paid-faster',
    title: 'Invoice Best Practices to Get Paid Faster',
    category: 'Business Finance',
    excerpt: 'Improve payment cycles with clear terms, milestone billing, and professional invoice formats.',
    readMinutes: 5,
    relatedTool: '/invoice',
  },
  {
    slug: 'simple-system-to-manage-household-bills',
    title: 'A Simple System to Manage Household Bills',
    category: 'Financial Planning',
    excerpt: 'Build a bill calendar for utilities, school fees, rent, and subscriptions to avoid penalties.',
    readMinutes: 5,
    relatedTool: '/general-bill',
  },
  {
    slug: 'investment-checklist-before-you-buy-any-fund',
    title: 'Investment Checklist Before You Buy Any Fund',
    category: 'Investing',
    excerpt: 'Run a quality checklist on objective, risk, costs, and consistency before allocating capital.',
    readMinutes: 7,
    relatedTool: '/mf-returns',
  },
  {
    slug: 'index-funds-vs-active-funds-in-india',
    title: 'Index Funds vs Active Funds in India',
    category: 'Investing',
    excerpt: 'Compare costs, consistency, and risk to decide when passive beats active and when it may not.',
    readMinutes: 8,
    relatedTool: '/mf-returns',
  },
  {
    slug: 'step-up-sip-why-it-accelerates-goals',
    title: 'Step Up SIP: Why It Accelerates Goals',
    category: 'Investing',
    excerpt: 'Learn how annual SIP step ups can materially improve corpus outcomes without sudden stress.',
    readMinutes: 6,
    relatedTool: '/goal-sip',
  },
  {
    slug: 'how-to-handle-market-corrections-calmly',
    title: 'How to Handle Market Corrections Calmly',
    category: 'Behavioral Finance',
    excerpt: 'Use process based investing rules to avoid panic decisions when markets are volatile.',
    readMinutes: 6,
    relatedTool: '/sip',
  },
  {
    slug: 'salary-hike-allocation-rule-that-works',
    title: 'Salary Hike Allocation Rule That Works',
    category: 'Financial Planning',
    excerpt: 'Split every increment smartly across lifestyle upgrades, goals, and long term wealth creation.',
    readMinutes: 5,
    relatedTool: '/salary',
  },
  {
    slug: 'new-job-finance-checklist-first-90-days',
    title: 'New Job Finance Checklist: First 90 Days',
    category: 'Financial Planning',
    excerpt: 'From emergency fund to tax declarations, secure your finances quickly after a role change.',
    readMinutes: 6,
    relatedTool: '/salary',
  },
  {
    slug: 'bonus-money-how-to-use-it-wisely',
    title: 'Bonus Money: How to Use It Wisely',
    category: 'Financial Planning',
    excerpt: 'Create a priority order for bonus cash so short term joy and long term goals both win.',
    readMinutes: 5,
    relatedTool: '/goal-sip',
  },
  {
    slug: 'how-to-prepare-for-a-single-income-phase',
    title: 'How to Prepare for a Single Income Phase',
    category: 'Financial Planning',
    excerpt: 'Build buffers and reduce fixed costs before planned career breaks or family transitions.',
    readMinutes: 7,
    relatedTool: '/fixed-income',
  },
  {
    slug: 'retirement-buckets-for-regular-income',
    title: 'Retirement Buckets for Regular Income',
    category: 'Retirement',
    excerpt: 'Design short, medium, and long term buckets to smooth withdrawals through market cycles.',
    readMinutes: 8,
    relatedTool: '/swp',
  },
  {
    slug: 'annuities-when-they-make-sense',
    title: 'Annuities: When They Make Sense',
    category: 'Retirement',
    excerpt: 'Understand where guaranteed pension income helps and where flexibility may matter more.',
    readMinutes: 7,
    relatedTool: '/nps',
  },
  {
    slug: 'early-retirement-healthcare-cost-planning',
    title: 'Early Retirement Healthcare Cost Planning',
    category: 'Retirement',
    excerpt: 'Plan realistic healthcare inflation and reserve strategy before pulling the retirement trigger.',
    readMinutes: 8,
    relatedTool: '/retirement',
  },
  {
    slug: 'understanding-rent-agreement-money-clauses',
    title: 'Understanding Rent Agreement Money Clauses',
    category: 'Real Estate',
    excerpt: 'Review escalation, deposit, maintenance, and penalty clauses to avoid future disputes.',
    readMinutes: 6,
    relatedTool: '/rent-receipt',
  },
  {
    slug: 'property-buying-hidden-costs-checklist',
    title: 'Property Buying Hidden Costs Checklist',
    category: 'Real Estate',
    excerpt: 'Account for legal, interiors, moving, and setup costs beyond down payment and EMI.',
    readMinutes: 6,
    relatedTool: '/stamp-duty',
  },
  {
    slug: 'gst-input-tax-credit-basics',
    title: 'GST Input Tax Credit Basics',
    category: 'Business Finance',
    excerpt: 'Understand ITC eligibility, invoice matching, and common compliance mistakes for small businesses.',
    readMinutes: 7,
    relatedTool: '/gst',
  },
  {
    slug: 'how-to-create-a-winning-local-business-poster',
    title: 'How to Create a Winning Local Business Poster',
    category: 'Business Finance',
    excerpt: 'Design promotional posters that drive attention, explain the offer clearly, and turn local traffic into real business leads.',
    readMinutes: 6,
    relatedTool: '/business-poster',
  },
  {
    slug: 'how-to-price-a-new-product-profitably',
    title: 'How to Price a New Product Profitably',
    category: 'Business Finance',
    excerpt: 'Set launch prices with target margin, demand sensitivity, and break even constraints in mind.',
    readMinutes: 7,
    relatedTool: '/markup',
  },
  {
    slug: 'cash-flow-buffer-for-small-businesses',
    title: 'Cash Flow Buffer for Small Businesses',
    category: 'Business Finance',
    excerpt: 'Build a survival runway to handle delayed receivables, seasonal dips, and surprise expenses.',
    readMinutes: 6,
    relatedTool: '/breakeven',
  },
  {
    slug: 'freelancer-tax-estimation-made-simple',
    title: 'Freelancer Tax Estimation Made Simple',
    category: 'Tax',
    excerpt: 'Estimate advance tax with a straightforward workflow and avoid year end cash flow shocks.',
    readMinutes: 7,
    relatedTool: '/income-tax',
  },
  {
    slug: 'section-80c-80d-and-beyond-planning-map',
    title: 'Section 80C, 80D and Beyond: Planning Map',
    category: 'Tax',
    excerpt: 'Map deductions clearly so you do not miss available tax benefits while planning investments.',
    readMinutes: 7,
    relatedTool: '/income-tax',
  },
  {
    slug: 'rsu-espp-tax-and-cashflow-planning',
    title: 'RSU and ESPP Tax and Cashflow Planning',
    category: 'Tax',
    excerpt: 'Plan vesting, sale timing, and tax outflows to avoid concentration and cash crunch risk.',
    readMinutes: 8,
    relatedTool: '/capital-gain',
  },
  {
    slug: 'gold-etf-vs-sovereign-gold-bond',
    title: 'Gold ETF vs Sovereign Gold Bond',
    category: 'Investing',
    excerpt: 'Choose the right gold exposure by comparing liquidity, taxation, and holding horizon.',
    readMinutes: 7,
    relatedTool: '/cagr',
  },
  {
    slug: 'how-to-design-a-no-spend-month',
    title: 'How to Design a No Spend Month',
    category: 'Budgeting',
    excerpt: 'Run a practical no spend challenge to reset habits without disrupting essential commitments.',
    readMinutes: 5,
    relatedTool: '/salary',
  },
  {
    slug: 'money-boundaries-for-family-loans',
    title: 'Money Boundaries for Family Loans',
    category: 'Financial Planning',
    excerpt: 'Set clear terms for family lending to protect relationships and financial stability.',
    readMinutes: 6,
    relatedTool: '/fixed-income',
  },
  {
    slug: 'ecommerce-profit-mistakes-first-time-sellers-make',
    title: 'E-commerce Profit Mistakes First Time Sellers Make',
    category: 'Business Finance',
    excerpt: 'Avoid underpricing traps by accounting for platform fees, returns, packaging, and ad spend correctly.',
    readMinutes: 7,
    relatedTool: '/ecommerce-profit',
  },
  {
    slug: 'how-to-price-after-marketplace-fees-and-returns',
    title: 'How to Price After Marketplace Fees and Returns',
    category: 'Business Finance',
    excerpt: 'Build a practical pricing buffer for commission, shipping leakage, and refund related costs.',
    readMinutes: 6,
    relatedTool: '/ecommerce-profit',
  },
  {
    slug: 'customer-loan-estimation-for-small-sellers',
    title: 'Customer Loan Estimation for Small Sellers',
    category: 'Loans',
    excerpt: 'Use quick EMI estimates to help customers choose plans they can repay comfortably.',
    readMinutes: 6,
    relatedTool: '/loan-estimator',
  },
  {
    slug: 'flat-rate-vs-reducing-rate-emi-explained',
    title: 'Flat Rate vs Reducing Rate EMI Explained',
    category: 'Loans',
    excerpt: 'Understand why similar headline rates can still produce very different total interest costs.',
    readMinutes: 7,
    relatedTool: '/emi',
  },
  {
    slug: 'lic-policy-estimates-before-you-commit',
    title: 'LIC Policy Estimates Before You Commit',
    category: 'Insurance',
    excerpt: 'Estimate premium outgo, projected maturity, and bonus assumptions before choosing a policy type.',
    readMinutes: 7,
    relatedTool: '/lic-plan',
  },
  {
    slug: 'how-to-use-shop-bill-history-for-budget-control',
    title: 'How to Use Shop Bill History for Budget Control',
    category: 'Budgeting',
    excerpt: 'Track recurring grocery and household spends using itemized bills to tighten monthly planning.',
    readMinutes: 5,
    relatedTool: '/shop-bill',
  },
  {
    slug: 'internet-bill-audit-for-households',
    title: 'Internet Bill Audit for Households',
    category: 'Financial Planning',
    excerpt: 'Audit plan speed, add-ons, and taxes quarterly so broadband expenses do not silently drift up.',
    readMinutes: 5,
    relatedTool: '/internet-bill',
  },
  {
    slug: 'bill-generator-workflow-for-freelancers-and-shops',
    title: 'Bill Generator Workflow for Freelancers and Shops',
    category: 'Business Finance',
    excerpt: 'Create a simple billing workflow with invoice numbering, due tracking, and payment-mode discipline.',
    readMinutes: 6,
    relatedTool: '/general-bill',
  },
];

const baseDate = new Date('2026-09-20T00:00:00.000Z');

const toDateLabel = (offsetDays) => {
  const d = new Date(baseDate);
  d.setUTCDate(d.getUTCDate() - offsetDays);
  return d.toISOString().slice(0, 10);
};

const categoryKeywordMap = {
  Budgeting: ['budget planning', 'expense tracking', 'monthly budget', 'saving money tips'],
  Investing: ['investment planning', 'sip planning', 'mutual funds india', 'wealth creation'],
  Retirement: ['retirement planning india', 'pension planning', 'retirement corpus', 'post retirement income'],
  Tax: ['income tax india', 'tax saving tips', 'tax planning', 'itr guidance'],
  Loans: ['loan planning', 'emi planning', 'debt management', 'credit score'],
  'Real Estate': ['property investment', 'rent vs buy', 'rental yield', 'home buying'],
  Insurance: ['term insurance', 'health insurance india', 'risk protection', 'insurance planning'],
  'Financial Planning': ['personal finance planning', 'goal based planning', 'money habits', 'family finance'],
  'Business Finance': ['small business finance', 'cash flow management', 'pricing strategy', 'gst compliance'],
  'Behavioral Finance': ['investor psychology', 'money mindset', 'behavioral investing', 'decision making'],
};

const getKeywords = (topic) => {
  const slugPhrase = topic.slug.replace(/-/g, ' ');
  const categoryKeywords = categoryKeywordMap[topic.category] || ['financial literacy', 'money management tips'];

  return [
    'paisapyara finance blog',
    'personal finance india',
    'money management',
    topic.category.toLowerCase(),
    topic.title,
    slugPhrase,
    ...categoryKeywords,
    'personal finance india',
    'financial planning blog',
  ].join(', ');
};

const createContent = (topic) => {
  const relatedSentence = topic.relatedTool
    ? `If you want to run numbers immediately, use the related calculator at ${topic.relatedTool}.`
    : 'Use a trusted calculator to verify your assumptions before taking action.';

  return [
    `${topic.title} is easiest to apply when you break the decision into small steps and use realistic assumptions instead of optimistic guesses.`,
    `Start by defining your target, timeline, and risk level. Then list your monthly cash flow constraints and lock a simple rule set you can follow even in busy months.`,
    `Review your progress every 30 days and adjust only one variable at a time, such as contribution amount, tenure, or expected return. This keeps decisions objective and measurable.`,
    relatedSentence,
  ].join('\n\n');
};

export const blogPosts = topics.map((topic, index) => ({
  id: index + 1,
  slug: topic.slug,
  title: topic.title,
  category: topic.category,
  excerpt: topic.excerpt,
  readMinutes: topic.readMinutes,
  publishedAt: toDateLabel(index * 3),
  relatedTool: topic.relatedTool,
  keywords: getKeywords(topic),
  content: createContent(topic),
}));

export const blogCategories = ['All', ...new Set(blogPosts.map((post) => post.category))];

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};

